var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wac-layout',[_c('wac-spacing',[_c('wac-cms-include',_vm._b({},'wac-cms-include',_vm.$props,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }